<template>
  <v-row class="mb-10 mt-5 pdfFrame">
    <v-col class="pa-0" v-if="checkConvertable">
      <!-- {{pdfCurrentPage}} / {{pdfPageCount}} -->
      <pdf
        v-for="i in numPages"
        :key="i"
        :page="i"
        :src="file"
        @num-pages="pdfPageCount = $event"
        @page-loaded="pdfCurrentPage = $event"
      />
    </v-col>
    <v-col v-else :inner-html.prop="file | sanitize"></v-col>
  </v-row>
</template>
<script>
import pdf from 'vue-pdf';
// import { getExtension } from '@/helpers/extensions';
import FileViewHelper from '@/helpers/FileViewHelper';
export default {
  components: {
    pdf
  },
  data() {
    return {
      file: '',
      pdfPageCount: 0,
      pdfCurrentPage: 0,
      numPages: undefined
    };
  },
  props: {
    fileExtension: String,
    src: String,
    openInModal: Boolean,
    wasConverted: Boolean
  },
  watch: {
    src: async function() {
      if (this.checkConvertable) {
        this.file = pdf.createLoadingTask(this.src);
        const loadingPdf = await this.file.promise;

        this.numPages = loadingPdf.numPages;
      } else {
        this.file = FileViewHelper(
          this.openInModal ? '.zip' : this.fileExtension,
          this.src
        );
      }
    }
  },
  computed: {
    checkConvertable() {
      if (this.wasConverted) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style>
.pdfFrame {
  border: 1px solid #eeeeee;
  height: 500px;
  overflow-y: scroll;
}
.text-center {
  text-align: center;
}
.icon-top4 {
  font-size: 24px;
  margin-right: 8px;
}

.max-width-100 {
  max-width: 100px;
}
</style>
